<template>
  <div class="xcxUpload">
    <div class="aside">
      <div class="aside-w">
        <img
          class="local"
          :src="require('/src/assets/img/upload/photo.png')"
          alt="本地上传"
        />
        <div class="upload" @click="upload">选择本地文件</div>
      </div>
    </div>
    <input ref="inputUpload" type="file" @change="callAsync($event)" />
    <input ref="inputUploadSame" type="file" @change="callAsync($event)" />
  </div>
</template>

<script>
import axios from "axios";
import { REQUEST_URL, CLOUD_REQUEST_URL, APP_KEY } from "src/const/const";
import { BMF } from "src/utils/utils";
import Miniprogram from "utils/miniprogram";

const miniProgram = new Miniprogram();
let instance;

export default {
  data() {
    return {};
  },
  mixins: [],
  methods: {
    // 防止同名文件无法重复上传
    upload() {
      this.$refs.inputUpload.click();
    },
    // 防止同名文件无法重复上传
    uploadSame() {
      this.$refs.inputUploadSame.click();
    },
    /**
     * [callAsync 同步执行]
     *
     * @param   {[type]}  e  [e description]
     *
     * @return  {[type]}     [return description]
     */
    async callAsync(e) {
      this.$message.loading({
        forbidClick: true,
        message: "上传中...",
        duration: 0
      });
      this.clearShow = !this.clearShow;
      const file = e.currentTarget.files[0];
      const fileName = file.name;
      e.target.value = "";
      const { size } = this.$route.query;
      if (file.size > Number(size)) return this.$message("上传文件过大!");
      if (!this.checkExtName(fileName)) return this.$message("仅支持pdf文件");
      BMF.md5(file, (err, md5) => {
        if (err && !md5) return this.$message("获取文件md5失败");
        // 上传文件
        this.uploadDocument(file, md5);
      });
    },
    /**
     * [callAsync 同步执行]
     *
     * @param   {[type]}  e  [e description]
     *
     * @return  {[type]}     [return description]
     */
    checkExtName(fileName) {
      const extName = this.getExtName(fileName);
      if (!extName) return false;
      const { type } = this.$route.query;
      if (type.split(",").find(item => item === extName)) return true;
      return false;
    },
    /**
     * [uploadDocument 上传文件]
     *
     * @return  {[type]}  [return description]
     */
    uploadDocument(file, md5) {
      const { accessToken } = this.$route.query;
      let params = new FormData();
      params.append("file", file);
      params.append("md5", md5);
      params.append("fileName", file.name);
      const headers = {
        "Content-Type":
          "multipart/form-data;boundary = " + new Date().getTime(),
        Authorization: `Bearer ${accessToken}`,
        appKey: APP_KEY
      };
      return new Promise((resolve, reject) => {
        miniProgram.init().then(res => {
          // qq小程序需要用户点击才能触发加载js
          instance = res;
          const service = axios.create({
            withCredentials: true,
            headers
          });
          const url = `${REQUEST_URL}/common/upload`;
          service.post(url, params).then(({ data: res }) => {
            if (res.code === 0) {
              this.$message("上传成功！");
              setTimeout(() => {
                instance.miniProgram.navigateBack();
                instance.miniProgram.postMessage({
                  data: {
                    fileInfo: res.data
                  }
                });
              }, 1000);
            } else {
              this.$message("网络波动，请重试");
              setTimeout(() => {
                instance.miniProgram.navigateBack();
              }, 1000);
            }
          });
        });
      });
    }
  },
  created() {
    document.title = "福昕智慧打印";
  },
  computed: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.xcxUpload {
  height: 100%;
  padding-top: 90px;
  .aside {
    width: 100%;
    .local {
      width: 376px;
      height: 340px;
      display: block;
      margin: 0 auto 120px;
    }
    .upload {
      width: 400px;
      border-radius: 50px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      background: #2f54eb;
      color: #fff;
      font-size: 28px;
      margin: 0 auto;
      font-weight: 500;
      font-size: 36px;
      border: none;
      outline: none;
      position: relative;
    }
  }
  input {
    display: none;
  }
}
</style>
